var GetMyPingData;

var PingOnGoingData;
window.CurrentOnGoingIndex = 1;
window.OnGoingLastPage = 1;
window.OnGoingObserver = null;

var PingPastData;
window.CurrentPastIndex = 1;
window.PastLastPage = 1;
window.PastObserver = null;

var LoadedHotelImageData = [];

var PingOnGoingNotFoundContainer;
var OnGoingPingPanelContainer;

var PastPingMainContent;
var PastPingPanelContainer;

var ExploreButton;

window.PrepareMyPingElement = function()
{
    document.getElementById("WhichPageSectionIsText").innerHTML = window["MyPingTxt" + window.CurrentCountryID];

    document.getElementById("PingOnGoingHeaderText").innerHTML = window["PingOnGoingTxt" + window.CurrentCountryID];
    document.getElementById("NoPingOnGoingHeaderText").innerHTML = window["NoPingOngoingHeadTxt" + window.CurrentCountryID];
    document.getElementById("NoPingOnGoingMessageText").innerHTML = window["NoPingOngoingMesTxt" + window.CurrentCountryID];

    document.getElementById("PastPingHeaderText").innerHTML = window["PastPingTxt" + window.CurrentCountryID];
    
    ExploreButton = document.getElementById("ExploreButton");
    ExploreButton.innerHTML = window["ExploreTxt" + window.CurrentCountryID];

    // Set Explore Button Default Button -------------------------------------------

    window.SetUpTopDateQuotaSearch(false);

    let ExploreButtonHREF = document.createElement("a");
    ExploreButtonHREF.className = "HREFInsideContainer";
    ExploreButtonHREF.href = "/search/" + window.CurrentCountryID + "/" +  window.DefaultSearchLocation.toLowerCase().replace(/\s+/g, '-')  + ".html?&search=" + window.DefaultSearchLocation + "&checkin=" + window.CheckInInfo + "&checkout=" + window.CheckOutInfo + "&room=" + 1;
    ExploreButton.append(ExploreButtonHREF);
}

window.PrepareMyPingInfoAfterCheckUser = function(thismaindata, loggedin)
{
    PastPingMainContent = document.getElementById("PastPingMainContent");
    PastPingPanelContainer = document.getElementById("PastPingPanelContainer");

    PingOnGoingNotFoundContainer = document.getElementById("PingOnGoingNotFoundContainer");
    OnGoingPingPanelContainer = document.getElementById("OnGoingPingPanelContainer");

    if(loggedin == true)
    {
        window.GetThisBookingData("OnGoing", thismaindata.usd_PING_id, thismaindata.usd_PING_tkn, OnGoingPingPanelContainer);
        window.GetThisBookingData("Past", thismaindata.usd_PING_id, thismaindata.usd_PING_tkn, PastPingPanelContainer);
    }
    else
    {
        PingOnGoingNotFoundContainer.style.display = "";
        OnGoingPingPanelContainer.remove();
        window.location.href = "/";
    }
}

// ========================== GET BOOKING INFO ==============================

window.GetThisBookingData = function(whichtype, thisuserid, tokenget, whichcontainer)
{
    let ThisEarlyLoadingArray = [];
    for(let i = 0; i < 5; i++)
    {
       ThisEarlyLoadingArray.push(window.InstantiateLoadingHotelPanel(whichcontainer));
    }

    // Loading Panel Immediatelly Instantiate -----------------------------------------

    let WhichMode = "on-going";
    let WhichIndex = window["Current" + whichtype + "Index"];

    if(whichtype == "Past")
        WhichMode = "past";

    let URLLoadBookingData = "/v2/users/" + thisuserid + "/bookings?mode=" + WhichMode + "&page=" + WhichIndex + "&lang=" + window.CurrentCountryID + "&token=" + tokenget;

    window.CallApiAxios({
        method: "GET",
        url: URLLoadBookingData,
    }).then(res =>
    {
        //console.log("!!!!!!!!!!!!!!!!!!!!! LOAD " + whichtype + " BOOKING DATA, PAGE " + WhichIndex + " !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!");
        //console.log(URLLoadBookingData);

        ThisEarlyLoadingArray.forEach(earlyloadingpanels => {
            earlyloadingpanels.remove();
        });

        if(res.status == 200)
        {
            let ThisBookingData = res.data;
            //console.log(ThisBookingData);

            if(ThisBookingData.data.length > 0)
            {
                if(whichtype == "Past")
                {
                    PastPingMainContent.style.display = "";
                }

                InstantiatePanelMyPing(ThisBookingData, whichtype);

                if(WhichIndex == 1) // Set Observer ------------------------------------
                {
                    let ThisScrollSentinel = document.getElementById("which" + whichtype + "Sentinel");
                    window[whichtype + "LastPage"] = ThisBookingData.pagination.last_page;
                    
                    let ThisDataObserverOption = {
                        pageKey: "Current" + whichtype + "Index",
                        lastPageKey: whichtype + "LastPage",
                        sentinelEl: ThisScrollSentinel,
                        functiontocall: () =>
                        {
                            return window.GetThisBookingData(whichtype, thisuserid, tokenget, whichcontainer);
                        }
                    };

                    window[whichtype + "ScrollObserver"] = window.makeObserver(ThisDataObserverOption);

                }
            }
            else
            {
                if(WhichIndex == 1 && whichtype == "OnGoing")
                {
                    PingOnGoingNotFoundContainer.style.display = "";
                    OnGoingPingPanelContainer.style.display = "none";
                }
            }
        }
    })
    .catch(err =>
    {
        ThisEarlyLoadingArray.forEach(earlyloadingpanels => {
            earlyloadingpanels.remove();
        });
        //console.error(err);
    });
}

// ================================== INSTANTIATE PING PANEL =====================================

function InstantiatePanelMyPing(whichdata, whichtype)
{
    let wheretoinstantiate = window[whichtype + "PingPanelContainer"];

    let WhichIndex = window["Current" + whichtype + "Index"];
    if(WhichIndex == 0)
        wheretoinstantiate.innerHTML = "";

    let WhichBookingData = whichdata.data;

    for(let i = 0; i < WhichBookingData.length; i++)
    {
        let MyPingLoadingContainer = window.InstantiateLoadingHotelPanel(wheretoinstantiate);
            
        // Outer container ------------------------------------------------------------
        let MyPingPanel = document.createElement("div");
        MyPingPanel.className = "RoomHotelPanel notanimatable";
        MyPingPanel.style.marginLeft = "0";
        MyPingPanel.style.marginRight = "0";
        MyPingPanel.style.width = "100%";
        MyPingPanel.style.display = "none";
        wheretoinstantiate.append(MyPingPanel); // Or append to another parent

        // Wrapper
        let MyPingWrapper = document.createElement("div");
        MyPingWrapper.className = "RoomHotelWrapper";
        MyPingPanel.append(MyPingWrapper);

        // -------------------------------------- Left Main section --------------------------------------
        let MyPingImageInsidePanel = document.createElement("div");
        MyPingImageInsidePanel.className = "RoomHotelImageInsidePanel";
        MyPingWrapper.append(MyPingImageInsidePanel);

        let WhichImageIsExist = null;

        for(let x = 0; x < LoadedHotelImageData.length; x++)
        {
            if(WhichBookingData[i].id_hotel == LoadedHotelImageData[x].id_hotel)
            {
                WhichImageIsExist = LoadedHotelImageData[x].image_list;
            }
        }

        if(WhichImageIsExist == null)
        {
            let UrlPhotoRoomData = "/v2/hotels/" + WhichBookingData[i].id_hotel + "/photos?page=1&limit=2";

            window.CallApiAxios({
                method: "GET",
                url: UrlPhotoRoomData,
            }).then(res =>
            {
                // //console.log(UrlPhotoRoomData);
                // //console.log(res);

                if(res.status == 200)
                {
                    let ThisMyPingImageData = res.data.data;

                    let RoomImagePhoto = 
                    {
                        "id_hotel":WhichBookingData[i].id_hotel,
                        "image_list":ThisMyPingImageData
                    }
                    LoadedHotelImageData.push(RoomImagePhoto);

                    InstantiateMyPingImage(ThisMyPingImageData, MyPingImageInsidePanel, MyPingPanel, MyPingLoadingContainer);
                }
            })
            .catch(err =>
            {
                //console.error(err);

                let NoImageError = document.createElement("img");
                NoImageError.className = "ImageFullCover";
                NoImageError.src = "/Assets/images/NoImage.jpeg";
                MyPingWrapper.append(NoImageError);
            });
        }
        else
        {
            InstantiateMyPingImage(WhichImageIsExist, MyPingImageInsidePanel, MyPingPanel, MyPingLoadingContainer);
        }

        // -------------------------------------- Right Main section --------------------------------------
        let RightSection = document.createElement("div");
        RightSection.className = "RoomHotelImageRightSectionInSeparatorsidePanel MyPingPanelContentContainer";
        MyPingWrapper.append(RightSection);

        // Left info wrapper --------------------------------------
        let LeftInfo = document.createElement("div");
        LeftInfo.className = "RoomHotelPanelInfoLeftWrapper";
        RightSection.append(LeftInfo);

        let RoomStatusNameWrapper = document.createElement("div"); // Room Status and Name -------------------
        RoomStatusNameWrapper.className = "RoomStatusandNameWrapper";
        LeftInfo.append(RoomStatusNameWrapper);

        let BookingStatusPanel = document.createElement("div"); // Room Status
        BookingStatusPanel.className = "RoomBenefitsPanel";
        if(WhichBookingData[i].status == "Booking Payment Timeout")
        {
            let statusIcon = document.createElement("img");
            statusIcon.className = "IconInsideRoundedPanel";
            statusIcon.src = "/Assets/images/ButtonIcon/orange-alert-triangle.svg";
            BookingStatusPanel.append(statusIcon);
        }
        RoomStatusNameWrapper.append(BookingStatusPanel);

        let StatusToDisplay = WhichBookingData[i].status;
        if(WhichBookingData[i].status_payment == "Success" && (WhichBookingData[i].status_booking == "Check-in" || WhichBookingData[i].status_booking == "Progress"))
        {
            StatusToDisplay = WhichBookingData[i].status_booking;
        }
        window.SetBackgroundAndTextColorBasedOnStatus(StatusToDisplay, BookingStatusPanel);

        let OrderNumberText = document.createElement("p"); // Order Number
        OrderNumberText.className = "BasicInputTextTop InterRegularTextFont TextToDisplayAfterCalc BasicMarginTopList";
        OrderNumberText.innerHTML = window["OrderNumberTxt" + window.CurrentCountryID] + ": ";
        RoomStatusNameWrapper.append(OrderNumberText);

        let OrderNumberCode = document.createElement("span");
        OrderNumberCode.className = "InterMediumItalicTextFont HyperlinkUnderlineText";
        OrderNumberCode.innerHTML = WhichBookingData[i].order_code;
        OrderNumberCode.onclick = function()
        {
            window.CopyToClipboardItem(WhichBookingData[i].order_code);
        }
        OrderNumberText.append(OrderNumberCode);

        let HotelNameText = document.createElement("p"); // Room Name
        HotelNameText.className = "RoomHotelNameInsidePanel InterBoldTextFont";
        HotelNameText.innerHTML = WhichBookingData[i].hotel.hotel_name;
        RoomStatusNameWrapper.append(HotelNameText);

        // Location -------------------------------------------------------------------------------
        let locationContainer = document.createElement("div");
        locationContainer.className = "RoomLocationContainerInsidePanel";
        locationContainer.style = "width: 100%; margin-left: 0; margin-right: 0; margin-top: 0;"
        LeftInfo.append(locationContainer);

        let locationIcon = document.createElement("img");
        locationIcon.src = "/Assets/images/ButtonIcon/location-icon.svg";
        locationIcon.className = "LocationIconInsidePanel";
        locationIcon.style.marginLeft = "0";
        locationIcon.style.marginRight = "0";
        locationContainer.append(locationIcon);

        let locationText = document.createElement("p");
        locationText.className = "RoomLocationTextInsidePanel InterMediumTextFont";
        locationText.style.width = "100%";
        locationText.style.flex = 1;
        locationText.innerHTML = WhichBookingData[i].hotel.city_region + ", " + WhichBookingData[i].hotel.province + " - ";
        locationContainer.append(locationText);

        let seeMapHREF = document.createElement("a");
        seeMapHREF.className = "SeeMapTextInsidePanel InterBoldTextFont HyperlinkUnderlineText";
        seeMapHREF.innerHTML = window["SeeMapTxt" + window.CurrentCountryID];
        seeMapHREF.target = "_blank";
        seeMapHREF.rel = "noopener noreferrer";
        seeMapHREF.href = WhichBookingData[i].hotel.link_gmaps;
        locationText.append(seeMapHREF);

        // Ping description -------------------------------------------------------------------------------

        let PingDescriptionToDisplay = WhichBookingData[i].hotel.hotel_description.replace(/(?:\r\n|\r|\n)/g, '<br>');
        PingDescriptionToDisplay = window.decodeGarbledContent(PingDescriptionToDisplay);

        let Pingdescription = document.createElement("p");
        Pingdescription.className = "RoomHotelDescriptionInsidePanel InterRegularTextFont";
        Pingdescription.innerHTML = PingDescriptionToDisplay;
        LeftInfo.append(Pingdescription);


        // Right info wrapper --------------------------------------
        
        let RightSectionRightWrapper = document.createElement("div");
        RightSectionRightWrapper.className = "RoomHotelPanelInfoRightWrapper";
        RightSectionRightWrapper.style="height: 100%; display: flex; flex-direction: column;";
        RightSection.append(RightSectionRightWrapper);

        // Right Section Mini Top ---------------------------------
        let RightSectionMiniTopWrapper = document.createElement("div");
        RightSectionMiniTopWrapper.className = "RoomBottomInfoLeft";
        RightSectionMiniTopWrapper.style.marginTop = "0";
        RightSectionRightWrapper.append(RightSectionMiniTopWrapper);

        let RoomNameDateBenefitWrapper = document.createElement("div");
        RoomNameDateBenefitWrapper.className = "InputFieldMargin3";
        RoomNameDateBenefitWrapper.style.flexDirection = "column";
        RightSectionMiniTopWrapper.append(RoomNameDateBenefitWrapper);

        let RoomNameDisplay = "-------";
        if(WhichBookingData[i].booking_details.length > 0)
            RoomNameDisplay = WhichBookingData[i].booking_details[0].room_ping.hotel_room.room_name

        let RoomNameQuantityText = document.createElement("p");
        RoomNameQuantityText.className = "LabelGreyHeaderText InterRegularTextFont";
        RoomNameQuantityText.style.marginLeft = "0px";
        RoomNameQuantityText.innerHTML = "<span class=\"InterBoldTextFont\">" + WhichBookingData[i].total_room + " x </span>" + RoomNameDisplay;
        RoomNameDateBenefitWrapper.append(RoomNameQuantityText);


        let CheckInInfoArray = WhichBookingData[i].date_checkin.split("-");
        let CheckInInfoYear = parseInt(CheckInInfoArray[0]);
        let CheckInInfoMonth = parseInt(CheckInInfoArray[1]);
        let CheckInInfoDate = parseInt(CheckInInfoArray[2]);

        let CheckOutInfoArray = WhichBookingData[i].date_checkout.split("-");
        let CheckOutInfoYear = parseInt(CheckOutInfoArray[0]);
        let CheckOutInfoMonth = parseInt(CheckOutInfoArray[1]);
        let CheckOutInfoDate = parseInt(CheckOutInfoArray[2]);

        let RoomCheckInandOutText = document.createElement("p");
        RoomCheckInandOutText.className = "PingToGoInsidePanel PingToGo3InsidePanel InterBoldTextFont";
        RoomCheckInandOutText.style.marginLeft = "0";
        RoomCheckInandOutText.innerHTML =  CheckInInfoDate + " " + window["monthNames" + window.CurrentCountryID][parseInt(CheckInInfoMonth) - 1] + " " + CheckInInfoYear +  " - " + CheckOutInfoDate + " " + window["monthNames" + window.CurrentCountryID][parseInt(CheckOutInfoMonth) - 1] + " " + CheckOutInfoYear;
        RoomNameDateBenefitWrapper.append(RoomCheckInandOutText);

        // Room Benefits -----------------------------------------------

        let RoomBenefitContainer = document.createElement("div");
        RoomBenefitContainer.className = "BlueColouredBenefits RoomHotelBenefitsInsidePanel";
        RoomNameDateBenefitWrapper.append(RoomBenefitContainer);

        let RoomBenefitSwiperWrapper = document.createElement("div");
        RoomBenefitSwiperWrapper.className = "swiper-wrapper";
        RoomBenefitContainer.append(RoomBenefitSwiperWrapper);

        let RoomSmokeType = document.createElement("div");
        RoomSmokeType.className = "RoomBenefitsPanel swiper-slide";
        RoomSmokeType.textContent = window.RoomPreferencesTxt(WhichBookingData[i].room_preference);
        RoomBenefitSwiperWrapper.append(RoomSmokeType);

        if(WhichBookingData[i].booking_details != null && WhichBookingData[i].booking_details.length > 0)
        {
            let ThisBenefitData = WhichBookingData[i].booking_details[0].room_ping.hotel_room.benefits;

            if(ThisBenefitData != null && ThisBenefitData.length > 0)
            {
                ThisBenefitData.forEach(ThisBenefits =>
                {
                    let RoomBenefitsText = document.createElement("div");
                    RoomBenefitsText.className = "RoomBenefitsPanel swiper-slide";
                    RoomBenefitsText.textContent = ThisBenefits["benefit_name_" + window.CurrentCountryID];
                    RoomBenefitSwiperWrapper.append(RoomBenefitsText);
                });
            }
        }

        let RoomBenefitSwiper = new window.Swiper(RoomBenefitContainer,
        {
            slidesPerView: 'auto',
            spaceBetween: 0,
            freeMode: true,
            observer: true,
            grabCursor: true,
            observeParents: true,
            autoplay: {
                delay: 5000,
            },
        });

        // User info section -----------------------------------------------

        let MyPingUserInfoContainer = document.createElement("div");
        MyPingUserInfoContainer.className = "UserSectionMyPing";
        RightSectionMiniTopWrapper.append(MyPingUserInfoContainer);

        let MyPingUserNameandSpecialInfoSeparator = document.createElement("div");
        MyPingUserNameandSpecialInfoSeparator.className = "WrapperUserInfoRightSection";
        MyPingUserInfoContainer.append(MyPingUserNameandSpecialInfoSeparator);

        let MyPingUserNameText = document.createElement("p");
        MyPingUserNameText.className = "BasicInputTextTop InterBoldTextFont";
        MyPingUserNameText.style.marginBottom = "0";
        MyPingUserNameText.innerHTML = WhichBookingData[i].name_customer;
        MyPingUserNameandSpecialInfoSeparator.append(MyPingUserNameText);

        // Phone & Email
        let ContactInfoWrapper = document.createElement("div");
        ContactInfoWrapper.className = "PhoneNumberAndEmailWrapper";
        MyPingUserNameandSpecialInfoSeparator.append(ContactInfoWrapper);

        let EmailTextWrapper = document.createElement("div");
        EmailTextWrapper.className = "EmailSeparatorWrapper";
        ContactInfoWrapper.append(EmailTextWrapper);

        let EmailText = document.createElement("p");
        EmailText.className = "SmallerRoomDescriptionText InterRegularTextFont";
        EmailText.style.color = "rgb(37, 37, 37)";
        EmailText.innerHTML = WhichBookingData[i].user.email;
        // EmailText.style.wordBreak = "break-all";
        EmailTextWrapper.append(EmailText);
        
        let GreyLineSeparator = document.createElement("div");
        GreyLineSeparator.className = "GreyLineSeparator";
        ContactInfoWrapper.append(GreyLineSeparator);

        let phoneWrapper = document.createElement("div");
        phoneWrapper.className = "PhoneNumberSeparatorWrapper";
        ContactInfoWrapper.append(phoneWrapper);

        let PhoneText = document.createElement("p");
        PhoneText.className = "SmallerRoomDescriptionText InterRegularTextFont";
        PhoneText.style.color = "rgb(37, 37, 37)";
        PhoneText.innerHTML = WhichBookingData[i].user.country_code + WhichBookingData[i].user.phone_number;
        // EmailText.style.wordBreak = "break-all";
        phoneWrapper.append(PhoneText);


        // Bottom Right (Total Payment) ------------------------------------------
        
        let BottomRightWrapper = document.createElement("div");
        BottomRightWrapper.className = "RoomBottomInfoRight";
        BottomRightWrapper.style.marginTop = "auto";
        RightSectionRightWrapper.append(BottomRightWrapper);

        let TotalPaymentandSeeDetailsWrapper = document.createElement("div");
        TotalPaymentandSeeDetailsWrapper.className = "TwoSeparatorWrapper InputFieldMargin";
        BottomRightWrapper.append(TotalPaymentandSeeDetailsWrapper);

        let TotalPaymentWrapper = document.createElement("div");
        TotalPaymentWrapper.className = "TwoSeparatorContent";
        TotalPaymentandSeeDetailsWrapper.append(TotalPaymentWrapper);

        let TotalPaymentHeaderText = document.createElement("p");
        TotalPaymentHeaderText.className = "RoomLocationTextInsidePanel InterRegularTextFont";
        TotalPaymentHeaderText.style.color = "#667085";
        TotalPaymentHeaderText.style.marginLeft = "0";
        TotalPaymentHeaderText.style.overflow = "visible";
        TotalPaymentHeaderText.innerHTML = window["TotalPaymentTxt" + window.CurrentCountryID];
        TotalPaymentWrapper.append(TotalPaymentHeaderText);

        let TotalPaymentAmount = document.createElement("p");
        TotalPaymentAmount.className = "OriginalPriceText InterBoldTextFont";
        TotalPaymentAmount.style.marginLeft = "0";
        TotalPaymentAmount.textContent = window.ConvertTextToRP(WhichBookingData[i].subtotal_hotel_payment, 1, false, false);
        TotalPaymentWrapper.append(TotalPaymentAmount);

        // Right Button
        let SeeDetailButtonWrapper = document.createElement("div");
        SeeDetailButtonWrapper.className = "TwoSeparatorContent";
        SeeDetailButtonWrapper.style.marginLeft = "auto";
        SeeDetailButtonWrapper.style.width = "fit-content";
        TotalPaymentandSeeDetailsWrapper.append(SeeDetailButtonWrapper);

        let SeeDetailButton = document.createElement("button");
        SeeDetailButton.className = "BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop Selectable";
        SeeDetailButton.textContent = window["SeeDetailsBtnTxt" + window.CurrentCountryID];
        SeeDetailButtonWrapper.append(SeeDetailButton);

        let SeeDetailButtonHREF = document.createElement("a");
        SeeDetailButtonHREF.className = "HREFInsideContainer";
        SeeDetailButtonHREF.href = "/bookingdetails/" + window.CurrentCountryID + "/" + WhichBookingData[i].booking_reference + ".html";
        SeeDetailButton.append(SeeDetailButtonHREF);
    }
}

function InstantiateMyPingImage(whichdata, MyPingImageInsidePanel, MyPingPanel, MyPingLoadingContainer)
{
    let FunctionToCallAfterLoaded = function()
    {
        MyPingLoadingContainer.remove();
        MyPingPanel.style.display = "";
    }

    window.CheckAllImageRemoveEmptyAndWaitLoadCallFunc(whichdata, "hotel_photo", "/Assets/images/NoImage.jpeg", MyPingImageInsidePanel, { quality: 70}, MyPingPanel, ()=>FunctionToCallAfterLoaded());
}